<!--
 * @message: 
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2022-03-09 14:35:29
 * @FilePath: \mrc-ess-fronted\src\Page\EssAdmin\Leave\LeaveBalance\components\viewLeaveBalance.vue
 * @最后编辑: Betway
 * @最后修改时间: 2022-03-24 13:18:30
-->
<template>
  <v-navigation-drawer
    v-model="drawer"
    width="427"
    right
    @input="onChange"
    temporary
    fixed
    :overlay-opacity="0"
  >
    <v-container
      fluid
      class="d-flex flex-column justify-space-around pa-0 fill-height"
    >
      <v-toolbar flat dense class="pr-3" style="width: 100%">
        <v-toolbar-title class="text-subtitle-2">
          <v-list-item-title class="table-subttile text--primary">{{
            curRow
              ? $getCommonLangValue(curRow["leave_type_name"])
              : $t("label_essweb_leaveBalance_list_title_detail")
          }}</v-list-item-title>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-tooltip left>
          <template v-slot:activator="{ on }">
            <v-btn
              icon
              v-on="on"
              @click.stop="drawer = false"
              color="black"
              small
            >
              <span class="material-icons-round">close</span>
            </v-btn>
          </template>
          <span>{{
            $t("label_essweb_RosterRecord_slide_adhoc_closeBtnTip")
          }}</span>
        </v-tooltip>
      </v-toolbar>
      <v-container
        fluid
        class="pa-0 scroll_content_no mrc-grey"
        :style="{ height: 'calc(100% - 108px)' }"
      >
        <Taber
          v-if="taber.length > 0"
          :curTab="curTab"
          @change="(tab) => (curTab = tab)"
          :items="taber"
          border
          closeTranslate
          :height="40"
          special
          :rounded="false"
          contentBackground="fill-height"
          backgroundColor="white"
        >
          <template
            :slot="`content-${index + 1}`"
            v-for="(item, index) in taber"
          >
            <v-row dense :key="`balance${index}`">
              <v-col xs="12" sm="12" md="12" lg="12" cols="12">
                <v-container fluid class="pa-0 ma-0">
                  <v-sheet
                    v-for="(header, i) in headers"
                    :key="`header${i}`"
                    v-if="header.value !== 'action'"
                  >
                    <v-divider></v-divider>
                    <v-sheet class="d-flex text-body-m pa-4 align-center">
                      {{ header.text }}
                      <v-spacer></v-spacer>
                      {{ getText(header, deserts[index]) }}
                    </v-sheet>
                  </v-sheet>
                </v-container>
              </v-col>
              <v-divider></v-divider>
              <v-col
                xs="12"
                sm="12"
                md="12"
                lg="12"
                cols="12"
                class="pa-4 mrc-grey"
              >
                <v-sheet class="primary rounded-lg pa-4" :elevation="3">
                  <v-sheet class="text-h6 transparent white--text">{{
                    $t("label_essweb_leaveBalance_form_futureBalanceLabel")
                  }}</v-sheet>
                  <v-sheet
                    class="
                      text-right text-h3
                      transparent
                      white--text
                      font-weight-bold
                    "
                    >{{
                      getText(
                        headers.find(
                          (ele) => ele.value === "leave_future_balance"
                        ),
                        deserts[index],
                        false
                      )
                    }}</v-sheet
                  >
                  <v-sheet
                    class="text-right text-caption transparent white--text"
                    >{{
                      deserts[index]["unit"] === "D"
                        ? $t("label_essweb_system_dayLabel")
                        : deserts[index]["unit"] === "H"
                        ? $t("label_essweb_system_hourLabel")
                        : ""
                    }}</v-sheet
                  >
                </v-sheet>
              </v-col>
              <v-col
                xs="12"
                sm="12"
                md="12"
                lg="12"
                cols="12"
                class="text-center text--secondary mrc-grey text-caption"
                v-if="deserts[index]['last_sync_updated_date']"
              >
                {{ $t("label_essweb_leaveBalance_form_lastestUpdateTime") }}:{{
                  $getDateTime(
                    deserts[index]["last_sync_updated_date"],
                    "YYYY/MM/DD"
                  )
                }}
              </v-col>
            </v-row>
          </template>
        </Taber>
        <noContent v-else />
      </v-container>
      <v-spacer></v-spacer>
      <v-sheet
        height="60"
        class="
          align-center
          text-center
          flex-row
          d-flex
          justify-center
          max-width
        "
        style="border-top: 1px solid var(--main-border-color)"
      >
        <v-btn
          color="primary"
          height="32"
          rounded
          class="pl-7 pr-7 text-capitalize mr-2"
          @click="drawer = false"
          >{{ $t("label_shut_down") }}</v-btn
        >
      </v-sheet>
    </v-container>
  </v-navigation-drawer>
</template>
<script>
import dayjs from "dayjs";
export default {
  name: "viewLeaveBalance",
  props: {
    headers: { default: [], type: Array },
  },
  computed: {
    taber() {
      let arr = [];
      this.deserts.map((item) => {
        arr.push(dayjs(item.start_date).format("YYYY"));
      });
      return arr;
    },
  },
  data() {
    return {
      curRow: null,
      drawer: false,
      standard_working_minutes: 1,
      deserts: [],
      curTab: "tab-1",
    };
  },
  watch: {
    drawer(v) {
      if (!v) {
        this.curRow = null;
        this.deserts = [];
        this.standard_working_minutes = 1;
        this.curTab = "tab-1";
      }
    },
  },
  filters: {
    CalculationByDHFilter: function (minutes, obj, callback) {
      return callback(minutes, obj["unit"]);
    },
  },
  mounted() {},
  methods: {
    view(staff, leave_type_uuid, mode, item) {
      this.curRow = item;
      this.getDetail(staff, leave_type_uuid, mode);
      this.drawer = true;
    },
    getText(header, item, isUnit = true) {
      if (header?.permission) {
        if (Number(item[header.permission])) {
          if (header.tran) {
            return this.$getCommonLangValue(item[header.value]);
          } else {
            if (header.value == "unit") {
              return item["unit"] === "D"
                ? isUnit
                  ? this.$t("label_essweb_system_dayLabel")
                  : ""
                : item["unit"] === "H"
                ? isUnit
                  ? this.$t("label_essweb_system_hourLabel")
                  : ""
                : "";
            } else {
              if (header?.unit) {
                return this.CalculationByDH(
                  item[header.value],
                  item["unit"],
                  isUnit
                );
              } else {
                return item[header.value];
              }
            }
          }
        } else {
          return "-";
        }
      } else {
        if (header.tran) {
          return this.$getCommonLangValue(item[header.value]);
        } else {
          if (header.value == "unit") {
            return item["unit"] === "D"
              ? isUnit
                ? this.$t("label_essweb_system_dayLabel")
                : ""
              : item["unit"] === "H"
              ? isUnit
                ? this.$t("label_essweb_system_hourLabel")
                : ""
              : "";
          } else {
            if (header?.unit) {
              return this.CalculationByDH(
                item[header.value],
                item["unit"],
                isUnit
              );
            } else {
              return item[header.value];
            }
          }
        }
      }
    },
    onChange() {},
    CalculationByDH: function (minutes, unit, isUnit) {
      let stand = this.standard_working_minutes;
      if (
        minutes === undefined ||
        minutes === null ||
        minutes === "" ||
        unit === null ||
        unit === ""
      ) {
        return (
          minutes + (isUnit ? this.$t("label_essweb_system_minutesLabel") : "")
        );
      }
      if (unit === "D") {
        if (stand === "" || stand === null) {
          return (
            minutes +
            (isUnit ? this.$t("label_essweb_system_minutesLabel") : "")
          );
        }
        return (
          parseFloat((Number(minutes) / Number(stand)).toFixed(4)) +
          (isUnit ? this.$t("label_essweb_system_dayLabel") : "")
        );
      } else if (unit === "H") {
        return (
          parseFloat((Number(minutes) / 60).toFixed(4)) +
          (isUnit ? this.$t("label_essweb_system_hourLabel") : "")
        );
      } else {
        return (
          minutes + (isUnit ? this.$t("label_essweb_system_minutesLabel") : "")
        );
      }
    },
    getDetail(staff, leave_type_uuid, mode) {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_lv_leave_application_record",
        url: "/leave/get-vacation-balance/",
        data: {
          staff_uuid: staff,
          mode: mode,
          leave_type_uuid: leave_type_uuid,
        },
      }).then((res) => {
        that.standard_working_minutes = res.data["standard_working_minutes"];
        that.deserts = res.data["ess_lv_leave_balance"];
      });
    },
  },
};
</script>